<template>
  <a-modal
    centered
    title="高级检索"
    v-model="visible"
    width="70%"
    okText="确认"
    :footer="null"
    @cancel="onCancel"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :destroyOnClose="true"
  >
    <dataForm :colnum="2" :content="content" :labelCol="8" :wrapperCol="16">
      <template slot="slot1">
        <a-input-group compact>
          <a-input style="width: 70%" defaultValue="Xihu District, Hangzhou" />
          <a-select defaultValue="0" style="width: 30%">
            <a-select-option value="0">大于</a-select-option>
            <a-select-option value="1">等于</a-select-option>
          </a-select>
        </a-input-group>
      </template>
      <template slot="slot2">
        <a-input-group compact>
          <a-input style="width: 70%" defaultValue="Xihu District, Hangzhou" />
          <a-select defaultValue="0" style="width: 30%">
            <a-select-option value="0">大于</a-select-option>
            <a-select-option value="1">等于</a-select-option>
          </a-select>
        </a-input-group>
      </template>
      <template slot="slot3">
        <a-input-group compact>
          <a-input style="width: 70%" defaultValue="Xihu District, Hangzhou" />
          <a-select defaultValue="0" style="width: 30%">
            <a-select-option value="0">大于</a-select-option>
            <a-select-option value="1">等于</a-select-option>
          </a-select>
        </a-input-group>
      </template>
      <template slot="slot4">
        <a-input-group compact>
          <a-input style="width: 70%" defaultValue="Xihu District, Hangzhou" />
          <a-select defaultValue="0" style="width: 30%">
            <a-select-option value="0">大于</a-select-option>
            <a-select-option value="1">等于</a-select-option>
          </a-select>
        </a-input-group>
      </template>
      <template slot="slot5">
        <a-input-group compact>
          <a-input style="width: 70%" defaultValue="Xihu District, Hangzhou" />
          <a-select defaultValue="0" style="width: 30%">
            <a-select-option value="0">大于</a-select-option>
            <a-select-option value="1">等于</a-select-option>
          </a-select>
        </a-input-group>
      </template>
      <template slot="slot6">
        <a-input-group compact>
          <a-input style="width: 70%" defaultValue="Xihu District, Hangzhou" />
          <a-select defaultValue="0" style="width: 30%">
            <a-select-option value="0">大于</a-select-option>
            <a-select-option value="1">等于</a-select-option>
          </a-select>
        </a-input-group>
      </template>
    </dataForm>
    <div class="form-action">
      <a-button type="primary" @click="onSubmit">确认</a-button>
      <a-button @click="onCancel">取消</a-button>
    </div>
  </a-modal>
</template>
<script>
import dataForm from "@/components/dataForm/DataForm";
import moment from "moment";
moment.locale("zh-cn");
export default {
  name: "CustomerManage",
  components: {
    dataForm
  },
  data() {
    return {
      email: "",
      confirmLoading: false,
      visible: false,
      content: [
        {
          label: "状态", //标题
          type: "select",
          valueField: "value",
          textField: "text",
          name: "OfferCreditSign",
          data: [
            {
              value: 1,
              text: "协议"
            },
            {
              value: 2,
              text: "挂账"
            },
            {
              value: 3,
              text: "禁用"
            }
          ]
        },
        {
          label: "卡号",
          placeholder: "请输入客人名称",
          name: "Name"
        },
        {
          label: "电话",
          placeholder: "请输入电话",
          name: "Name"
        },
        {
          label: "启用日期",
          name: "dateRange",
          type: "date-range",
          props: {
            placeholder: ["开始日期", "结束日期"]
          },
          option: {
            rules: [{ required: true, message: "Please select your country!" }]
          }
        },
        {
          label: "余额",
          slot: "slot1"
        },
        {
          label: "消费总额",
          slot: "slot3"
        },
        {
          label: "积分总额",
          slot: "slot4"
        },
        {
          label: "积分余额",
          slot: "slot5"
        }
      ]
    };
  },
  created() {},
  methods: {
    show() {
      this.visible = true;
    },
    onSubmit() {},
    onCancel() {
      this.visible = false;
      // if (this.enterFrom == "roomStatus") {
      //   this.$emit("update");
      // }
      this.$emit("destroy");
    }
  }
};
</script>

<style lang="less" scoped>
.form-action {
  text-align: center;
  .ant-btn {
    margin-right: 10px;
  }
}
</style>
